var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 19,
    viewBox: "0 0 27 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-177.000000, -1415.000000) translate(140.000000, 1255.000000) translate(26.000000, 160.000000) translate(11.000000, 0.000000)",
    stroke: "#000",
    strokeWidth: 1.039,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.52,
    y: 0.835,
    width: 25.42,
    height: 16.915,
    rx: 3.118
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.53,
    y: 11.23,
    width: 5.575,
    height: 3.685,
    rx: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.5124996L26.4599981 5.5124996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50499939 11.1824992L15.1199989 11.1824992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.88999986 11.1824992L6.61499952 11.1824992"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.11a43271aebd09f3166df299bce7beb0.svg";
export { ForwardRef as ReactComponent };